import styled from "styled-components";

export const WomensHeading = styled.div`
  display: flex;
  border-bottom: 1px solid lightgray;
  margin-bottom: 20px;
  h1 {
    background: url("https://i.pinimg.com/originals/82/c8/e5/82c8e5cdc7365418188bf4d1a943afe2.gif");
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 256px;
    margin: 0 auto;
  }
`;

export const ProductsGrid = styled.div`
  //   display: grid;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
